import { Badge, Button } from '@mui/material'
import { useConnectedWallet } from '@terra-money/wallet-provider'
import MailIcon from 'assets/icons-orange/mail.svg'
import usePilotGatewayTx from 'hooks/usePilotGatewayTx'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useModal } from 'react-modal-hook'
import { gatewayService } from 'services/gatewayService'
import { betaLaunchStore } from 'stores'
import InvitationModal from './Modal/InvitationModal'

const Invitation = observer(() => {
  // maxInviteWhitelist load in the same time with maxTVL
  const connectedWallet = useConnectedWallet()
  const { sendInvite, txStatusInvite } = usePilotGatewayTx()
  const [inviteAmount, setInviteAmount] = useState(0)
  const [showModal, hideModal] = useModal(() => {
    return (
      <InvitationModal
        amount={inviteAmount}
        onClose={hideModal}
        sendInvite={sendInvite}
      />
    )
  }, [sendInvite, inviteAmount])

  useEffect(() => {
    const fetch = async () => {
      if (!connectedWallet) {
        setInviteAmount(0)
        return
      }
      const [slot, gatewayConfig] = await Promise.all([
        gatewayService.getSlotWhitelisted(connectedWallet.walletAddress),
        gatewayService.getConfig(),
      ])
      setInviteAmount(gatewayConfig.max_ref - slot)
      betaLaunchStore.setMaxInviteWhitelist(gatewayConfig.max_ref)
    }
    fetch()

    return () => {
      setInviteAmount(0)
    }
  }, [connectedWallet, txStatusInvite])

  return (
    <Badge badgeContent={inviteAmount} color="error">
      <Button
        onClick={showModal}
        variant="outlined"
        sx={{ minWidth: '48px', width: '48px', height: '48px' }}
      >
        <img src={MailIcon} alt="MailIcon" width={24} height={24} />
      </Button>
    </Badge>
  )
})
export default Invitation
